<template>
  <div  class="pwdUpdateMain">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="110">
        <Row>
            <Col span="8" offset="10">
               <span style="font-weight:800;font-size:24px;margin-top:16px;display:inline-block;">修改密码</span>
            </Col>
        </Row>
        <br>
        <Row>
            <Col span="8" offset="6">
                <FormItem label="原密码" prop="oldPwd" :class="{requireStar:true}" >
                  <Input v-model="formValidate.oldPwd"  :maxlength="16" ></Input>
                </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="8" offset="6">
                  <FormItem label="新密码" prop="newPwd" :class="{requireStar:true}">
                    <Input v-model="formValidate.newPwd"   :maxlength="16"></Input>
                  </FormItem>
            </Col>
        </Row>
        <Row>
            <Col  span="8" offset="6">
                  <FormItem label="重复新密码" prop="newPwd2" :class="{requireStar:true}">
                    <Input v-model="formValidate.newPwd2"   :maxlength="16"></Input>
                  </FormItem>
            </Col>
        </Row>
        <Row>
            <Col  span="8" offset="10">
                <Button type="primary" size="large" @click="handleSubmit('formValidate')">保存</Button>
            </Col>
        </Row>
      </Form>
  </div>
</template>
<script>
  export default {
    data() {
         //自定义密码验证规则
          const validateOldPwd = (rule, value, callback)=> {
              if (value === '') {
                  callback(new Error('请输入原密码'));
              }else{
                let reg = /^.{6,16}$/
                if (!reg.test(value)) {
                  return callback(new Error('密码必须6到16位'));
                }else{
                  callback();
                }
              }
          };
          const validatePwd = (rule, value, callback)=> {
              if (value === '') {
                  callback(new Error('请输入新密码'));
              } else {
                let reg = /^.{6,16}$/
                if (!reg.test(value)) {
                  return callback(new Error('密码必须6到16位'));
                }  else{
                  callback();
                }
              }
          };
          const validatePwdCheck = (rule, value, callback)=>{
              if (value === '') {
                  return callback(new Error('请重复输入新密码'));
              } else if (value !== this.formValidate.newPwd) {
                  return callback(new Error('两次新密码不一致'));
              } else {
                  callback();
              }
          };
      
      return {
        modelForm: false,
        formValidate: {
          oldPwd: '',
          newPwd: '',
          newPwd2: '',
        },
        ruleValidate: {
          oldPwd:  [{validator: validateOldPwd, trigger: 'blur' }],
          newPwd:  [{validator: validatePwd, trigger: 'blur' }],
          newPwd2: [{validator: validatePwdCheck, trigger: 'blur' }],
        },
      }
    },

    methods: {
      
      handleSubmit(name) {

        this.$refs[name].validate((valid) => {
          if (valid) {
            let url = "/province/sys/user/updatePwd";
            let myData = {
              id: this.$store.state.user.id,
              oldPwd: this.formValidate.oldPwd,
              newPwd: this.formValidate.newPwd,
            }
            this.req({
              url: url,
              method: 'post',
              data: myData
            }).then(response => {
              if (response.status == 200) {
                let result = response.data.result
                if (result == "0") {
                   this.$Message.error('原密码错误');
                }else{
                   this.$Message.success('密码修改成功!');
                   this.handleReset("formValidate")
                }
              } else {
                this.$Message.error('服务器错误:' + response.status);
              }
            }).catch(error => {
              this.reponseData = "发生错误，无法显示内容"
            })
          } else {
            return;
          }
        }) 
      },
      handleReset(name) {
         if (this.$refs[name]!==undefined) {
              this.$refs[name].resetFields();
          }
      },
    },
    mounted() {
      this.handleReset("formValidate")
    },
  }
</script>
<style scoped>
  /*动态必填项className*/
  .pwdUpdateMain >>> .requireStar .ivu-form-item-label:before{
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed4014;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/sys/user/PasswordUpdate.vue